import React, { useEffect } from "react";

const Translate = () => {
  useEffect(() => {
    const googleTranslateElementInit = () => {
      if (window.google && window.google.translate) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,hi,ta,te,ml,kn,gu,mr,pa,bn,or,as,ur",
            autoDisplay: false,
          },
          "google_translate_element"
        );
      }
    };

    window.googleTranslateElementInit = googleTranslateElementInit;

    const addScript = document.createElement("script");
    addScript.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    addScript.async = true;
    addScript.onload = () => {
      console.log("Google Translate script loaded successfully.");
    };
    addScript.onerror = () => {
      console.error("Failed to load Google Translate script.");
    };
    document.body.appendChild(addScript);

    const observer = new MutationObserver(() => {
      const gadget = document.querySelector(".goog-te-gadget");

      if (gadget) {
        gadget.childNodes.forEach((node) => {
          if (
            node.nodeType === Node.TEXT_NODE &&
            node.textContent.includes("Powered by")
          ) {
            node.textContent = node.textContent.replace("Powered by", "");
          }
        });
        const selectElement = gadget.querySelector("select");
        if (selectElement) {
          selectElement.addEventListener("change", (e) => {
            if (e.target.value === "en") {
              window.location.reload();
            }
          });
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
      if (addScript.parentNode) {
        addScript.parentNode.removeChild(addScript);
      }
    };
  }, []);

  return <div id="google_translate_element"></div>;
};

export default Translate;
